import { RM11_01 } from "./RM11_01";

export const RM11 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "colorTheme": 'colorTheme2',
        "title": "RECOVERED CALLS",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Count',
                        "value": 'TotalCount',
                        "type": 'column'

                    }
                ],
                "title": 'SubCycle',
                "endpoint": "RM11",
                "parameters": [
                    { key: "CycleCode", value: "CP1" },
                    { key: "CycleYear", value: "2026" },
                    { "key": "RegionCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": RM11_01
                }
            }
        }
    }
}